const token = document.currentScript.getAttribute("data-token");
const baseUrl = document.currentScript.getAttribute("base-url") + "/api/public/";
const tagScript = document.getElementById("script-widget-base-url");

const getHeaders = () => {
    let authToken = localStorage.widgetAuthTokenCustomer;
    let headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        token: token,
        mode: "cors",
    };
    if (authToken) {
        headers.Authorization = `Bearer ${authToken}`;
    }
    return headers;
};

const post = async (url = "", data = {}) => {
    let headers = getHeaders();
    const response = await fetch(url, {
        method: "POST",
        headers,
        body: JSON.stringify(data)
    });
    return await response.json();
};

const get = async (url = "") => {
    let headers = getHeaders();
    const response = await fetch(url, {
        method: "GET",
        headers
    });
    return await response.json();
};


export const customerLogin = (email, password) => {
    let baseUrl = tagScript.dataset.widgetBaseUrl
    let url = `${baseUrl}/api/login`
    let data = {
        email: email,
        password: password,
        is_customer_auth: true,
        page_url: window.location.href,
    };
    return post(url, data);
}

export const getCustomerOrders = () => {
    let baseUrl = tagScript.dataset.widgetBaseUrl
    return get(baseUrl + '/api/account/orders')
}

export const getCustomerLastOrder = () => {
    let baseUrl = tagScript.dataset.widgetBaseUrl
    return get(baseUrl + '/api/account/last-order')
}

// Products of one earlier order; null when it is not available to this customer
export const getOrderForReorder = async (id) => {
    let baseUrl = tagScript.dataset.widgetBaseUrl
    const response = await fetch(`${baseUrl}/api/account/orders/${id}/reorder`, {
        method: "GET",
        headers: getHeaders()
    });
    if (!response.ok) {
        return null;
    }
    return await response.json();
}

export const customerLogout = () => {
    let baseUrl = tagScript.dataset.widgetBaseUrl
    return get(baseUrl + '/api/logout')
}

export const customerForgotPassword = (email) => {
    let baseUrl = tagScript.dataset.widgetBaseUrl
    let url = `${baseUrl}/api/forgot-password`
    let data = {
        email: email,
        is_customer: true,
        page_url: window.location.href,
    };
    return post(url, data);
}

export const customerResetPassword = ({token, email, password, passwordConfirmation}) => {
    let baseUrl = tagScript.dataset.widgetBaseUrl
    let url = `${baseUrl}/api/reset-password`
    let data = {
        token: token,
        email: email,
        password: password,
        password_confirmation: passwordConfirmation,
        is_customer: 1,
    };
    return post(url, data);
}

export const getWidget = () => {
    return get(baseUrl + "widget");
};

export const getSchedule = day => {
    return get(baseUrl + "schedule/" + day);
};

export const submitOrder = form => {
    return post(baseUrl + "submit-order", {...form, page_url: window.location.href});
};

export const getSettings = () => {
    return get(baseUrl + "settings");
};

export const getProducts = () => {
    return get(baseUrl + "products");
};
